import React, { useState, useEffect, useRef } from 'react'
import { motion, AnimatePresence } from 'framer-motion';
import MyScoreView from './MyScoreView';
import { copyStringToClipboard, convertMovesToEmojis } from '../logic/ShareStrings'
import RemoteScoreView from './RemoteScoreView';

const StatsPopup = ({closePopup, scoreInfo, isArchive}) => {
  const ref = useRef(null)
  const [viewHeight, setViewHeight] = useState(0)
  const [copiedSuccess, setCopiedSuccess] = useState(false)
  console.log(scoreInfo)
  useEffect(() => {
    const updateDimensions = () => {
      if (ref.current) {
        setViewHeight(ref.current.clientHeight)
      }
    };

    // Call the updateDimensions function initially and on each update
    updateDimensions();
    window.addEventListener('resize', updateDimensions);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  const containerStyle = {
    height: '100%', 
    width: '100%', 
    backdropFilter: 'blur(8px)',
    backgroundColor: 'rgba(255, 255, 255)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }

  const xButtonStyle = {
    position: 'absolute',
    height: '8%',
    width: '8%',
    top: '3%',
    right: '3%',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
  };

  const containerTopBodyStyle = {
    fontFamily: 'ProtoMono-Regular',
    textAlign: 'center',
    width: '88%',
    padding: '5%',
    fontSize: `${viewHeight * .05}px`,
    color: '#314f4d'
  }

  const containerBodyStyle = {
    fontFamily: 'ProtoMono-Regular',
    textAlign: 'center',
    // width: '92%',
    padding: '2%',
    marginTop: '5%',
    paddingBottom: '1%',
    fontSize: `${viewHeight * .04}px`,
    color: '#314f4d'
  }

  const letsGoButtonStyle = {
    display: "flex",
    fontFamily: 'ProtoMono-Regular',
    fontSize: `${viewHeight * .04}px`,
    padding: "2% 4%",
    margin: "3%",
    backgroundColor: "#569FA9",
    color: "white",
    borderRadius: "5px",
    cursor: "pointer",
    flexBasis: '50%',
    textAlign: 'center',
    justifyContent: "center",
    alignItems: "center"
  }
  const buttonsRow = {
    display: 'flex',
    width: '75%',
    marginTop: '2%',
    justifyContent: 'center',
    flexDirection: 'row'
  }
  const shareStyle = {
    marginLeft: '6%',
    marginRight: '-5%'
  }

  const statLabelStyle = {
    fontFamily: 'ProtoMono-Regular',
    textAlign: 'center',
    padding: '1% 1% 3% 1%',
    marginBottom: '5%',
    fontSize: `${viewHeight * .05}px`,
    color: '#314f4d'
  }


  const archiveStatBlock = {
    marginTop: '25%'
  }

  const copyScore = () => {
    if (scoreInfo.bestScore != '-') {
      copyStringToClipboard(convertMovesToEmojis(scoreInfo.bestScore, scoreInfo.bestMovesString, scoreInfo.gameNumber, scoreInfo.bestGameAlignedNumber))
      setCopiedSuccess(true)
      setTimeout(() => {
        setCopiedSuccess(false);
      }, 1500);
    }
  }

  return <div ref={ref} style={containerStyle}>
    { isArchive && 
      <div style={archiveStatBlock}> 
        <div style={statLabelStyle}>
          {`Ali9n #${scoreInfo.gameNumber} Global Stats:`}
        </div>
        {
          (scoreInfo.remoteScoreInfo && scoreInfo.remoteScoreInfo.buckets) && 
          <RemoteScoreView scoreInfo={scoreInfo} size={viewHeight * .86} isArchive={isArchive}/>
        }
      </div>
    }
    { !isArchive && 
      <div>
        <div>
          <div style={containerTopBodyStyle}>
            {'Your Stats:'}
          </div>
          <MyScoreView scoreInfo={scoreInfo} size={viewHeight}/>
          {
            (scoreInfo.remoteScoreInfo && scoreInfo.remoteScoreInfo.buckets) && 
            <div style={containerTopBodyStyle}>
              {`Today's Global Stats:`}
            </div>
          }
          {
            (scoreInfo.remoteScoreInfo && scoreInfo.remoteScoreInfo.buckets) && 
            <RemoteScoreView scoreInfo={scoreInfo} size={viewHeight}/>
          }
        </div>
      </div>
    }
    
    <img 
      style={xButtonStyle}
      src={process.env.PUBLIC_URL + '/svgs/close.svg'}
      onClick={closePopup}
      id='closePopup'
    />
    
  </div>
}

export default StatsPopup;


